<template>
  <div>
    <div class="item" v-if="type==='object'">
      <img :src="info.avatarUrl" class="avatar">
      <div class="line">
        <div>
          <div class="id">ID: {{ info.id }}</div>
          <div>{{ info.name }}</div>
        </div>
      </div>
    </div>
    <div class="item" v-if="type==='param'">
      <img :src="avatarUrl" class="avatar">
      <div class="line">
        <div>
          <div class="id">ID: {{ id }}</div>
          <div>{{ name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    id: String,
    name: String,
    avatarUrl: String,
    info: Object,
  },
};
</script>
<style lang="less" scoped>
.item {
  display: flex;
  align-items: center;

  .avatar {
    width: 50px;
    height: 50px;
    margin-right: 5px;
    border-radius: 50%;
  }

  .id {
    font-weight: bold;
  }

  .line {
    line-height: 25px;
  }
}
</style>
